module.exports = require("react-motion");


/*****************
 ** WEBPACK FOOTER
 ** external "react-motion"
 ** module id = 133
 ** module chunks = 0
 **/